document.addEventListener("DOMContentLoaded", function() {
    const impressionenSlider = document.querySelectorAll('.impressionen-slider');

    impressionenSlider.forEach((slider) => {
        const swiper = new Swiper(slider, {
            direction: 'horizontal',
            slidesPerView: "auto",
            spaceBetween: 30,
            grabCursor: true,
            loop: true,
            autoplay: {
                delay: 2500,
                disableOnInteraction: false,
            },
        });
    });
});